module.exports = __webpack_public_path__ + "static/media/kehuxinxi1.e542ba43.png";